<template>
  <section class="faq-item-section">
    <div class="wrapper">
      <div class="heading" @click="expand = !expand">
        <div class="question">{{ q }}</div>
        <div v-if="expand" class="icon icon-minus" />
        <div v-else class="icon icon-plus" />
      </div>

      <div v-if="expand" class="answer" v-html="a"></div>
      <Divider v-if="!last" margin-top="0px" height="1px" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Divider from '@/components/Divider.vue'

const props = defineProps<{
  q: string
  a: string
  open: boolean
  last: boolean
}>()

const expand = ref(props.open)
</script>

<style lang="scss" scoped>
.faq-item-section {
  @include base-font;

  .wrapper {
    @include flex-column;
    padding: 0 24px;
    gap: $spacing-4;
    background: $grey-25;
    color: $grey-300;
    align-items: flex-start;

    &:last-child {
      padding-bottom: 0;
    }

    .question {
      font-weight: 600;
    }

    @include mobile {
      padding: 0;
    }
  }

  .heading {
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
    user-select: none;
    gap: $spacing-4;
    cursor: pointer;
  }

  .answer:deep {
    @include markdown-display;

    a {
      color: $brand-tertiary;
    }
  }

  .icon {
    font-size: 20px;
    color: $grey-100;
  }
}
</style>
